import { css } from "../../../styled-system/css";

export const styles = {
  card: () =>
    css({
      position: "relative",
      fontWeight: 400,
      color: "headlineGrey",
      transition: "border 300ms ease-in-out",
      minHeight: "106px",
      _hover: {
        border: "1px solid",
        borderColor: "linkBlue",
        cursor: "pointer",
      },
    }),
  title: () =>
    css({
      fontSize: "body.butterfly",
      lineHeight: "body.butterfly",
      letterSpacing: "body.butterfly",
      color: "headlineGrey",
    }),
  footer: () =>
    css({
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    }),
  contentValue: () =>
    css({
      fontSize: "body.mouse",
      lineHeight: "body.mouse",
      letterSpacing: "body.mouse",
      paddingBottom: "baseUnit.mobile1",
      minWidth: "204px",
    }),
  viewReport: (expired: boolean) =>
    css({
      fontWeight: "bold",
      fontSize: "body.mouse",
      lineHeight: "body.mouse",
      letterSpacing: "body.mouse",
      color: "linkBlue",
      display: "flex",
      alignItems: "center",
      marginBottom: expired ? 0 : "6px",
    }),
  img: () =>
    css({
      marginRight: "baseUnit.mobile1",
      display: "flex",
      alignItems: "center",
    }),
  risk: () =>
    css({
      display: "flex",
      flexDirection: "column",
      mobile: {
        flexDirection: "row",
      },
    }),
  riskInfo: (displayShortCard?: boolean) =>
    css({
      position: "absolute",
      right: "baseUnit.mobile2",
      order: displayShortCard ? -1 : 0,
      mobile: {
        order: 0,
      },
    }),
  purchasedField: () =>
    css({
      order: -2,
      mobile: {
        display: "none",
      },
    }),
};
